import { Platform, StyleSheet } from "react-native";
export const styles = StyleSheet.create({
  modalBackground: {
    flex: 1,
    backgroundColor: "white", // Background layer color
  },
  FilterHeaderText: {
    fontSize: 18,
    fontWeight: "600",
    textAlign: "left",
    color: "#000",
  },
  FilterHeader: {
    paddingHorizontal: 15,
  },
  FilterHeaderFlex: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: 10,
  },

  container: {
    flex: 1,
    width: "100%",
  },

  containerBtnText: {
    fontSize: 16,
    color: "#000",
    textAlign: "center",
  },
  containerBtn: {
    width: "100%",
    paddingVertical: 20,
    marginTop: 40,
    textAlign: "center",
  },
  modalHeader: {
    fontSize: 26,
    fontWeight: "bold",
    textAlign: "left",
  },
  modalContainer: {
    justifyContent: "center",
    width: "100%",
    textAlign: "center",
    position: "absolute",
    // top: '30%',
    paddingTop: Platform.OS === "web" ? 0 : 40,
    height: "100%",
    alignItems: "center",
  },
  modalSubtitle: {
    fontSize: 16,
    marginTop: 6,
    color: "#707070",
  },
  modalWrap: {
    backgroundColor: "white",
    width: "100%",
    height: "100%",
    minHeight: "100%",
    borderRadius: 3,
    paddingVertical: Platform.OS === "web" ? 0 : 30,
    paddingBottom: 20,
    // paddingHorizontal: 16,
  },
});
